import React from 'react';
import '../ProMaxLoader.css';

const ProMaxLoader = ({ 
  size = 20, 
  color = 'currentColor', 
  text = 'Processing...', 
  showText = true,
  variant = 'default' // default, pulse, glow, advanced
}) => {
  const getSizeClass = () => {
    if (size <= 18) return 'size-18';
    if (size <= 24) return 'size-24';
    return '';
  };

  const getVariantClass = () => {
    switch (variant) {
      case 'pulse': return 'promax-pulse';
      case 'glow': return 'promax-glow';
      case 'advanced': return 'promax-advanced';
      default: return '';
    }
  };

  return (
    <div className="promax-loader" style={{ color }}>
      <div className={`promax-spinner ${getSizeClass()} ${getVariantClass()}`} />
      {showText && (
        <span style={{ 
          marginLeft: '8px', 
          fontSize: '14px', 
          fontWeight: '500',
          opacity: 0.9
        }}>
          {text}
        </span>
      )}
    </div>
  );
};

export default ProMaxLoader;